export default __webpack_public_path__ + "static/media/gmc.fe8d3e12.svg";